import { CSSProperties } from 'react';

import {
  toastEnterDurationMs,
  toastExitDelayMs,
} from '~/components/toasts-layout/toast-timings';
import { ToastPosition } from '~/stores/use-toasts/useToasts';

const wrapperPaddingX = 20;
export const offsetBetweenToasts = 20;

const absolutePositions: Record<ToastPosition, { x: string; y: string }> = {
  [ToastPosition.TopLeft]: { x: 'left', y: 'top' },
  [ToastPosition.Top]: { x: 'middle', y: 'top' },
  [ToastPosition.TopRight]: { x: 'right', y: 'top' },
  [ToastPosition.BottomLeft]: { x: 'left', y: 'bottom' },
  [ToastPosition.Bottom]: { x: 'middle', y: 'bottom' },
  [ToastPosition.BottomRight]: { x: 'right', y: 'bottom' },
};

interface ToastStyleProps {
  position: ToastPosition;
  offsetY: number;
  enterFrom?: boolean;
  exiting?: boolean;
}

const getHorizontalTransform = ({
  position,
  enterFrom,
  exiting,
}: ToastStyleProps): string => {
  if (enterFrom || exiting) {
    const dir =
      absolutePositions[position].x === 'left' ? '-100% - ' : '100% + ';
    return `translateX(calc(${dir}${wrapperPaddingX}px))`;
  }
  return 'translateX(0px)';
};

const getVerticalTransform = ({
  position,
  offsetY,
  enterFrom,
  exiting,
}: ToastStyleProps): string => {
  const sign = absolutePositions[position].y === 'top' ? '-' : '+';
  if (enterFrom || exiting) {
    return `translate(-50%, calc(${sign}100% ${sign} ${offsetY}px ${sign} ${offsetBetweenToasts}px))`;
  }
  return 'translate(-50%, 0px)';
};

export const getToastDynamicStyles = (
  props: ToastStyleProps
): CSSProperties => {
  const { x, y } = absolutePositions[props.position];
  const exitDelay = props.exiting ? toastExitDelayMs : 0;
  const isMiddle = x === 'middle';

  const transform = isMiddle
    ? getVerticalTransform(props)
    : getHorizontalTransform(props);

  return {
    transition: `top ${toastEnterDurationMs}ms ${exitDelay}ms cubic-bezier(0.73, 1.45, 0.75, 0.98), bottom ${toastEnterDurationMs}ms ${exitDelay}ms cubic-bezier(0.73, 1.45, 0.75, 0.98), transform ${toastEnterDurationMs}ms cubic-bezier(0.73, 1.45, 0.75, 0.98)`,
    left: x === 'left' ? `${wrapperPaddingX}px` : isMiddle ? '50%' : 'unset',
    right: x === 'right' ? `${wrapperPaddingX}px` : 'unset',
    top: y === 'top' ? `${props.offsetY}px` : 'unset',
    bottom: y === 'bottom' ? `${props.offsetY}px` : 'unset',
    transform,
  };
};
